import React from 'react';
import { Navigate } from 'react-router-dom';
import { contaEhAdmin, obterToken } from '../../services/api';

const RotaPrivada = ({ children }) => {
  const token = obterToken();
  if (!token) {
    return <Navigate to="/admin" replace />;
  }

  if (!contaEhAdmin()) {
    return <Navigate to="/admin?erro=acesso-negado" replace />;
  }

  return children;
};

export default RotaPrivada;
